import _ from 'lodash';

import { adminClient as apolloClient } from '@/store/apollo';

import BillingInvoicesPaginatedGql from '@/store/graphql/system/queries/BillingInvoicesPaginated.gql';

export default {
    fetchInvoicesPaginated: (data, userId = null) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            const variables = {
                scope: _.get(data, 'scope', 'base'),
                type: _.get(data, 'type', 'billing_invoice'),
                currentPage: _.get(data, 'pageInfo.currentPage', 1),
                perPage: _.get(data, 'pageInfo.perPage', 10),
                order: _.get(data, 'variables.order', 'created_at'),
                direction: _.get(data, 'variables.direction', 'desc'),
                filters
            };

            if (userId) {
                variables.userId = parseInt(userId, 10);
            }

            apolloClient
                .query({
                    query: BillingInvoicesPaginatedGql,
                    variables,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.BillingInvoicesPaginated))
                .catch(err => reject(err));
        })
};
